
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coronavirus",
      function () {
        return require("private-next-pages/coronavirus.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coronavirus"])
      });
    }
  